import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DomSanitizer} from "@angular/platform-browser";


@Component({
    selector: 'fuse-setting-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class DefaultFormDialogComponent implements OnInit
{
  action: string;
  dialogTitle;
  public editorContent = ``;
  public editorConfig = {
    placeholder: ""
  };
  title;
  active;
  html;
  privacy;
    constructor(
        public dialogRef: MatDialogRef<DefaultFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any, private satinaizer: DomSanitizer
    )
    {
        this.action = data.action;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = 'tutorial.edit';
            this.title = data.data.name;
            this.active = data.data.active;
            this.editorContent = data.data.text;
            this.privacy = data.privacy;
        }
      if ( this.action === 'new' )
        {
            this.dialogTitle = 'tutorial.new';
        }
      if ( this.action === 'show' )
      {
        this.dialogTitle =  data.data.active;
        this.html = data.data.text;
      }
    }

    ngOnInit()
    {

    }
}

